import { LANGUAGE } from '@src/utils/locale/index';

export default function getLanguageByPath() {
  const pathList = window.location.pathname.split('/').filter(item => !!item);
  const lang = pathList[pathList.length - 1];
  const langList = Object.keys(LANGUAGE);
  return langList.find(item => pathList.reverse().find(pathItem => pathItem === item)) || 'zh-Hant';
}
